import { doc, getDoc } from 'firebase/firestore'

import { db } from 'utils/firebase'

import { RemoteConstantsValues } from 'types/remoteConstants'

export const fetchConstants = async (): Promise<RemoteConstantsValues> => {
  const constantsRef = doc(db, '_admin', 'CONSTANTS')
  const constantsDoc = (await getDoc(constantsRef)).data()
  if (!constantsDoc) throw new Error('No constants found')

  return constantsDoc as RemoteConstantsValues
}
